import player1Svg from './player.svg'
import player2Svg from './player2.svg'
import player3Svg from './player3.svg'

export const playersSvgs = {
  0: player1Svg, 
  1: player2Svg,
  2: player3Svg
}